import { Checkbox } from "@eworkit/iris";

import { withFormikField } from "./withFormikField";

export const FormikCheckbox = withFormikField(Checkbox);
